// Lugares de las pantallas de venta cerrada donde Promociones monta sus piezas; vacíos no pintan nada.
import type { ReactNode } from 'react';
import type { SaleLine, SalePromotionInfo } from '@/api/services/retail-wizard/contract';

/** La venta cerrada que recibe el slot de beneficios. */
export interface SlotSale extends SalePromotionInfo {
    saleId: string;
    folio: string;
    lines: SaleLine[];
}

/** Precio original, promo o código y precio final de una línea, con la venta a la que pertenece. */
export type LinePromotionSlot = (line: SaleLine, sale: SlotSale) => ReactNode;

/** Cupón y «lo que se lleva» al pie de la venta. */
export type SaleBenefitsSlot = (sale: SlotSale) => ReactNode;

/** Nombre de un regalo cuando la línea solo trae su SKU; `lineName` es el que se mostraría sin él. */
export type GiftNameSlot = (line: SaleLine, sale: SlotSale, lineName: string) => ReactNode;

export interface SaleSlots {
    linePromotion?: LinePromotionSlot;
    giftName?: GiftNameSlot;
    saleBenefits?: SaleBenefitsSlot;
}

/** Arma lo que recibe el slot de beneficios, sin campos de promo ausentes. */
export function toSlotSale(
    sale: { saleId: string; folio: string } & SalePromotionInfo,
    lines: SaleLine[],
): SlotSale {
    return {
        saleId: sale.saleId,
        folio: sale.folio,
        lines,
        ...(sale.salePromotionId !== undefined && { salePromotionId: sale.salePromotionId }),
        ...(sale.salePromotionVersion !== undefined && {
            salePromotionVersion: sale.salePromotionVersion,
        }),
    };
}
